import { Component, HostListener } from '@angular/core';
import { SharedModule } from '../modules/shared/shared.module';
import { ReturnTopButtonComponent } from "../common/return-top-button/return-top-button.component";
import { SearchDossiersComponent } from "../common/search-dossiers/search-dossiers.component";
import { SharedService } from '../services/shared/shared.service';
import { RappelAbonnement } from '../pages/rappel-abonnement.component';
import { MenuBurgerComponent } from "../common/menu-burger/menu-burger.component";
import { BackdropComponent } from "../common/backdrop/backdrop.component";
import { Router } from '@angular/router';
import { ChangePassword } from '../pages/changePassword.component';
import { DialogEmail } from '../dialog/dialogEmail.component';
import { SafeHtmlPipe } from "../helpers/pipes/safe-html/safe-html.pipe";
import { MaintenanceService } from '../services/maintenance/maintenance.service';
import { INTERVAL_DELAY } from 'app/helpers/var/common';

@Component({
    selector: 'app-container',
    standalone: true,
    templateUrl: './app-container.component.html',
    styleUrl: './app-container.component.css',
    imports: [SharedModule, ReturnTopButtonComponent, SearchDossiersComponent, MenuBurgerComponent, BackdropComponent, SafeHtmlPipe]
})
export class AppContainerComponent 
{
    idService!:number
    isMaintenance:boolean = false
    maintenanceText: string = "Espace abonné / représentant en maintenance"
    displayApp:boolean = false
    
    constructor
    (
        private sharedService: SharedService,
        private maintenanceService: MaintenanceService,
        private router: Router
    ) 
    {
        const id_service = this.sharedService.getIdService()
        this.idService = id_service

        this.checkIfLoginIsNotEmail()
        this.checkIfDefaultPassword()
    }

    ngOnInit()
    {
        this.getDataPopup()
        this.checkMaintenanceInterval()
    }

    checkIfLoginIsNotEmail()
    {
        const sessionStorage_loginIsNotAnEmail = sessionStorage.getItem("loginIsNotAnEmail")
        if( sessionStorage_loginIsNotAnEmail )
        {
            const loginIsNotAnEmail:boolean = JSON.parse(sessionStorage_loginIsNotAnEmail)
            
            if( loginIsNotAnEmail == true )
            {
                this.sharedService.openDialog(DialogEmail)
            }
            else
            {
                sessionStorage.removeItem("loginIsNotAnEmail")
            }
        }
    }

    checkIfDefaultPassword()
    {
        const change_password = JSON.parse((sessionStorage.getItem("default_password") as string)) || false

        if(change_password && this.router.url !== "profil") 
        {
            this.needToChangePassword()
        }
    }

    checkMaintenanceInterval()
    {
        this.checkIfMaintenance()

        setInterval(() => {
            this.checkIfMaintenance()
        }, INTERVAL_DELAY)
    }

    needToChangePassword()
    {
        this.sharedService.openDialog(ChangePassword)
    }

    checkIfMaintenance()
    {
        this.maintenanceService.getData().subscribe(data => {
            const is_maintenance = data?.[0]?.IS_MAINTENANCE || false
            const contenu = data?.[0]?.CONTENU || ""

            if(contenu) this.maintenanceText = contenu

            if(is_maintenance === true)
            {
                this.isMaintenance = true
                this.toggleMaintenance({status:is_maintenance})
            }
            else
            {
                this.isMaintenance = false
                this.toggleMaintenance({status:false})
            }
        })
    }

    getDataPopup()
    {
        this.sharedService.getDataPopup(this.idService).subscribe(data => {
            setTimeout(() => {
                if( parseInt(data[0].NB_EDIT) > 0 && sessionStorage.length > 0 ) this.sharedService.openDialog(RappelAbonnement)
            }, 1000)
        })
    }

    @HostListener('window:resize', [])
    onWindowResize() 
    {
        const sidebar = (document.getElementById("sidebar") as HTMLElement)

        if(sidebar && window.innerWidth >= 1400) 
        {
            sidebar.style.display = 'initial'
        }
        if(sidebar && window.innerWidth < 1400) 
        {
            sidebar.style.display = 'none'
        }
    }

    switchToTabletMode()
    {
      return this.sharedService.switchToTabletMode()
    }
    
    toggleMaintenance(response:{status:boolean})
    {
        this.isMaintenance = response.status

        response.status == true
            ? this.displayApp = false
            : this.displayApp = true
    }
}
